import React, {useCallback, useContext, useState, useEffect} from 'react';
import {Popup, setOptions, Button, toast} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/patientVisitsSummary.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import Loading from "../utils/Loading";
import Empty from "../utils/Empty";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import BalloonBlock from "@ckeditor/ckeditor5-build-balloon-block";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
  theme: 'ios',
  themeVariant: 'light',
});

function PatientVisitsSummary({locale, dialog, Dialog, patient, width, summary, setSummary}) {
  const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
  const [loading, setLoading] = useState(true);

  const DialogClose = useCallback(() => {
    Dialog({view: 'close'});
  }, [Dialog]);

  const Summary = () => {

    const message = {
      type: 'wss',
      path: 'visits-summary',
      action: 'get',
      data: {
        user: patient
      }
    };
    wsCall(message);
  }

  const GetVisitsSummary = useCallback(data => {
    if (data.summary) {
      setSummary(data.summary);
    }
    if (data.error) {
      toast({message: locale.patientVisitsSummary.b, color: 'danger', display: 'bottom', duration: 3000});
    }
    setLoading(false);
  }, [locale.patientVisitsSummary.b]);

  useEffect(() => {
    if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'visits-summary') {
      GetVisitsSummary(wsResponse.data);
      setWsResponse({});
    }
  }, [wsResponse, GetVisitsSummary, setWsResponse]);

  useEffect(() => {
    if (!summary) {
      Summary();
    } else {
      setLoading(false);
    }
  }, []);

  return (
      <Popup className="cs-patient-visits-summary-popup" scrollLock={false} closeOnOverlayClick={false} closeOnEsc={false} fullScreen={true} display="center" maxHeight="700" buttons={[]} isOpen={dialog.view === 'patientVisitsSummary'} onClose={DialogClose}>
        <div className="mbsc-grid cs-patient-visits-summary-header-col">
          <div className="mbsc-row cs-patient-visits-summary-header-row">
            {width > 576 &&
                <div className="mbsc-col cs-patient-visits-summary-header-col" />
            }
            <div className={width > 576 ? "mbsc-col cs-patient-visits-summary-header-col mbsc-align-center" : "mbsc-col cs-patient-visits-summary-header-col"} >
              <Button className="cs-patient-visits-summary-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                {locale.patientVisitsSummary.a}
              </Button>
            </div>
            <div className="mbsc-col cs-patient-visits-summary-header-col mbsc-align-right">
              <Button color="primary" variant="flat" className="mbsc-bold cs-patient-visits-summary-close-button" onClick={() => DialogClose()} >
                &nbsp;<FontAwesomeIcon className="cs-patient-visits-summary-close-icon" icon={faXmark} />
              </Button>
            </div>
          </div>
        </div>
        {loading &&
            <div className="cs-patient-visits-summary-loading" >
              <Loading />
            </div>
        }
        {!loading &&
            <div className="cs-patient-visit-triage-scroll" >
              <CKEditor
                  id="editor-summary"
                  onReady={editor => {editor.enableReadOnlyMode('editor-summary')}}
                  editor={BalloonBlock}
                  data={summary}
                  disableWatchdog={true}
              />
            </div>
        }
      </Popup>
  );
}

export default PatientVisitsSummary;
